import Api from "../../axios"

export const postEmployeeFeedback = async ({ employee_id, feedback, is_publish }) => {
  return await Api.post("/add_feedback", {
    employee_id,
    feedback,
    is_publish
  });
};